import React, { useContext } from "react"
import { TutorsFiltersForm } from "../../forms/tutors_filters"
import { DataContextActions } from "../../../../contexts"

export const ListFilters = () => {
  const { updateState } = useContext(DataContextActions)
  const submit = data => {
    updateState("tutorListFilters", data)
  }
  return <TutorsFiltersForm onSubmit={submit} />
}
